import React from "react";
import { BrlFormatCurrency, FormatPoints } from "../../../../lib";
import { Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import { useApp } from '../../../../contexts/AppContext';

export default function ProductRow({
  product,
  index,
  lastIndex,
  itemsCart,
  item,
  displayMode,
  checkout
}) {
  const { whitelabel } = useApp();
  const itemsBySeller = itemsCart?.[item] || [];
  const brandShipping =
    (product?.brand_uuid &&
      checkout?.cart?.shipping_by_brand?.[product.brand_uuid]) ||
    {};
  const priceMoney = parseFloat(product?.price?.BRL?.offer || product?.price?.BRL?.price || 0);
  const pricePoints = parseInt(product?.price?.points?.offer || product?.price?.points?.points || 0, 10);
  const shippingPrice = parseFloat(brandShipping?.shipping_amount || 0);
  const shippingPoint = parseFloat(brandShipping?.shipping_point || 0);
  const shippingDeadline =
    brandShipping?.shipping_deadline ??
    checkout?.cart?.shippingDeadline ??
    "-";

  const subtotalMoney = (() => {
    const productsTotal = itemsBySeller
      .map((p) => parseFloat(p?.price?.BRL?.offer || p?.price?.BRL?.price || 0) * (p.quantity || 1))
      .reduce((acc, val) => acc + val, 0);
    
    return productsTotal + shippingPrice;
  })();

  const subtotalPoints = (() => {
    const productsTotal = itemsBySeller
      .map((p) => parseFloat(p?.price?.points?.offer || 0) * (p.quantity || 1))
      .reduce((acc, val) => acc + val, 0);
    
    return productsTotal + shippingPoint;
  })();

  return (
    <React.Fragment>
      <Row>
        <Col className="col-8 mb-4">
          <p
            className="font-wl-400 mb-0 text-sm"
            style={{ color: whitelabel?.text_primary_color, opacity: 0.6 }}
          >
            {product?.short_description} ({product?.quantity} uni.)
          </p>
        </Col>
        <Col className="col-4 text-end">
          <p className="font-wl-700 mb-2 color-text-dark text-xs">
            {displayMode === "money" && BrlFormatCurrency(priceMoney)}
            {displayMode === "points" && `${FormatPoints(pricePoints)} pts`}
            {displayMode === "both" &&
              `${BrlFormatCurrency(priceMoney)} ou ${FormatPoints(pricePoints)} pts`}
          </p>
        </Col>

        {index === lastIndex && (
          <div className="font-wl-500">
            <Row className="mt-4">
              <Col>
                <p className="mb-0 color-text-dark text-mg">
                  Frete: {shippingDeadline} dias úteis
                </p>
              </Col>
              <Col className="text-end">
                <p className="color-text-dark">
                  {displayMode === "money" && BrlFormatCurrency(shippingPrice)}
                  {displayMode === "points" && `${FormatPoints(shippingPoint)} pts`}
                  {displayMode === "both" &&
                    `${BrlFormatCurrency(shippingPrice)} ou ${FormatPoints(shippingPoint)} pts`}
                </p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p className="color-text-dark text-mg">Subtotal</p>
              </Col>
              <Col className="text-end">
                <p className="color-text-dark">
                  {displayMode === "money" && BrlFormatCurrency(subtotalMoney)}
                  {displayMode === "points" && `${FormatPoints(subtotalPoints)} pts`}
                  {displayMode === "both" &&
                    `${BrlFormatCurrency(subtotalMoney)} ou ${FormatPoints(subtotalPoints)} pts`}
                </p>
              </Col>
            </Row>
          </div>
        )}
      </Row>
    </React.Fragment>
  );
}

ProductRow.propTypes = {
  product: PropTypes.object,
  index: PropTypes.number,
  lastIndex: PropTypes.number,
  itemsCart: PropTypes.object,
  item: PropTypes.string,
  displayMode: PropTypes.oneOf(["money", "points", "both"]),
  checkout: PropTypes.object,
};